import lazyLoad from "common/utils/lazyLoad";

export default lazyLoad(() => import(/* webpackChunkName: "TransactionPromotePillar" */ "."));
